import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Card, Row, Col, CardBody } from "reactstrap";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Link } from "react-router-dom";
import { Anchor } from "grommet";
import ShowQnA from "./ShowQnA";
// import Spinner from "../sample/spinner";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../css/course-catelog.css";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import Chip from "@material-ui/core/Chip";
import TitleIcon from "@material-ui/icons/Title";
import DescriptionIcon from "@material-ui/icons/Description";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import ScheduleIcon from "@material-ui/icons/Schedule";

class QandA extends Component {
  constructor(props) {
    super(props);
    const quesiaskedList = [];
    const allquesList = [];
    const topiclist = [];
    const allnaskedquesList = [];

    const topicwisequesList = [];
    const topicwiseLearnerQueList = [];

    const qtitle = "";
    const qpostedby = "";
    const qcreationdate = "";
    const qforumthreadsSize = "";
    const courseTopic = "";
    const qdescription = "";
    const qfile = "";
    const qforumtopicid = "";
    const description = "";
    const title = "";
    const askcourseTopic = "";
    const opid = "";

    this.state = {
      contentType: props.contentType,
      contentId: props.contentId,
      quesiaskedList,
      allquesList,
      allnaskedquesList,

      topicwisequesList,
      topicwiseLearnerQueList,
      modalIsOpen: false,

      checked: false,
      isaskeddata: false,
      isSearchedata: false,
      isreviewed: true,
      qtitle,
      qpostedby,
      qcreationdate,
      qforumthreadsSize,
      qdescription,
      qfile,
      qforumtopicid,
      topiclist,
      courseTopic,
      description,
      title,
      selectedAnsFile: null,
      askcourseTopic,
      opid,

      data: [],
      searchString: [],
      searchField: "",
      loading: false,
      isseltopic: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.selectCourseTopic = this.selectCourseTopic.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.routeChange = this.routeChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.getfillthegapdata();
  }

  async getfillthegapdata() {
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));

    axios
      .post("ForumTopic/qna", formData)
      .then((res) => {
        if (res.data.status === "200") {
          this.setState({
            quesiaskedList: res.data.quesiaskedList,
            allquesList: res.data.allquesList,
            // data: res.data.allquesList,
            topiclist: res.data.topiclist,
            opid: res.data.opid,
          });

          return res;
        }
        throw res;
      })
      .catch((error) => {
        toast.error("Please try again!!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }

  openModal() {
    this.setState({
      modalIsOpen: true,
    });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  selectCourseTopic(e) {
    this.setState({
      courseTopic: e.target.value,
      checked: false,
      isseltopic: true,
    });

    if (e.target.value) {
      this.getquetions(e.target.value);
    }
  }

  async getquetions(courseTopic) {
    // console.log(" getquetions  ");
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    formData.append("topic", courseTopic);
    axios
      .post("ForumTopic/topicwiseQna", formData)
      .then((res) => {
        if (res.data.status === "200") {
          this.setState({
            topicwisequesList: res.data.topicwisequesList,
            topicwiseLearnerQueList: res.data.topicwiseLearnerQueList,
            isseltopic: true,
          });

          return res;
        }
        throw res;
      })
      .catch((error) => {
        toast.error("Please try again!!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }

  routeChange(
    e,
    qtitle,
    qpostedby,
    qcreationdate,
    qforumthreadsSize,
    qdescription,
    qfile,
    qid
  ) {
    this.setState({
      isreviewed: "",
      qtitle: qtitle,
      qpostedby: qpostedby,
      qcreationdate: qcreationdate,
      qforumthreadsSize: qforumthreadsSize,
      qdescription: qdescription,
      qfile: qfile,
      qforumtopicid: qid,
    });
  }

  sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }
  handleSubmit(e) {
    e.preventDefault();
    this.saveaskedquestion();
  }
  async saveaskedquestion() {
    // this.setState({ isLoading: true });
    this.setState({ loading: true });
    if (this.state.selectedAnsFile) {
      let filename = this.state.selectedAnsFile.name.split(".").pop();
      if (
        filename !== "pdf" &&
        filename !== "jpg" &&
        filename !== "xls" &&
        filename !== "jpeg" &&
        filename !== "xlsx" &&
        filename !== "docx" &&
        filename !== "doc" &&
        filename !== "png" &&
        filename !== "zip" &&
        filename !== "rar" &&
        filename !== "txt"
      ) {
        toast.error(" upload only pdf/jpg/jpeg/docx/txt/xlsx files");
        await this.sleep(3000);
        this.setState({ loading: false });
        return;
      }
    }
    // console.log("this.state.description  =" + this.state.description);
    // console.log("this.state.title  =" + this.state.title);
    // console.log("this.state.askcourseTopic  =" + this.state.askcourseTopic);

    if (
      this.state.description === "" ||
      this.state.title === ""
      // this.state.askcourseTopic === ""
    ) {
      toast.error(" All Fields are mandatory ...");
      await this.sleep(3000);
      this.setState({ loading: false });
      return;
    } else if (this.state.askcourseTopic === "") {
      toast.error("Select atleast one  Course Topic...");
      await this.sleep(3000);
      this.setState({ loading: false });
      return;
    } else {
      var formData = new FormData();
      formData.append("type", localStorage.getItem("usertype"));
      formData.append("cofflearn", localStorage.getItem("state"));
      formData.append("fdesc", this.state.description);
      formData.append("coursePic", this.state.selectedAnsFile);
      formData.append("ftopic", this.state.title);
      formData.append("topic", this.state.askcourseTopic);
      formData.append("opid", this.state.opid);

      axios
        .post("ForumTopic/addqna", formData)

        .then((res) => {
          if (res.data.status === "200") {
            this.setState({
              loading: false,
              allquesList: res.data.allnaskedquesList,
              isaskeddata: true,
              modalIsOpen: false,
            });
            toast.success(res.data.msg);
            //window.location.reload(false);
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  }
  handleInputChange = (event) => {
    this.setState({
      searchField: event.target.value,
      isSearchedata: true,
    });
  };

  render() {
    if (!this.state.isreviewed) {
      return (
        console.log(" qtitle1  ==" + this.state.qtitle),
        (
          <ShowQnA
            title={this.state.qtitle}
            postedBy={this.state.qpostedby}
            creationDate={this.state.qcreationdate}
            forumThreadsSize={this.state.qforumthreadsSize}
            description={this.state.qdescription}
            filename={this.state.qfile}
            forumtopicid={this.state.qforumtopicid}
          />
        )
      );
    }

    let { searchField, allquesList } = this.state;

    let searchFieldnew = searchField.toString().trim().toLowerCase();

    let filterData = [];

    //console.log("allquesList =>", allquesList);

    allquesList.filter((item) => {
      if (
        item.qtitle !== null ||
        item.qtitle !== "" ||
        item.qpostedby !== null ||
        item.qcreationdate !== null ||
        item.qforumthreadsSize !== null ||
        item.qdescription !== null
      ) {
        filterData = allquesList.filter(
          ({
            qpostedby,
            qdescription,
            qtitle,
            qcreationdate,
            qforumthreadsSize,
          }) =>
            qpostedby.trim().toLowerCase().indexOf(searchFieldnew) >= 0 ||
            qdescription.trim().toLowerCase().indexOf(searchFieldnew) >= 0 ||
            qtitle.trim().toLowerCase().indexOf(searchFieldnew) >= 0 ||
            qcreationdate.trim().toLowerCase().indexOf(searchFieldnew) >= 0 ||
            qforumthreadsSize
              .toString()
              .trim()
              .toLowerCase()
              .indexOf(searchFieldnew) >= 0
        );
      }
    });

    return (
      <div className=" bg-color1 tesx p-5">
        <div class="card p-3">
          <div class="row ">
            <div class="col-md-8">
              <form>
                <div class="input-group">
                  <TextField
                    style={{ width: "100%" }}
                    id="filter"
                    value={this.state.searchField}
                    label="Search for..."
                    onChange={this.handleInputChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon className="icon-color-frm" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </form>
            </div>
            <div class="col-md-1 text-center">
              <span> Or </span>
            </div>
            <div class="col-md-3 text-left">
              <Link onClick={this.openModal}>
                <Button variant="contained" color="primary" type="submit">
                  {" "}
                  Ask a Question
                </Button>
              </Link>
              <Modal
                isOpen={this.state.modalIsOpen}
                onRequestClose={this.closeModal}
                size="md"
              >
                <ModalHeader className="header-modalc" toggle={this.closeModal}>
                  Ask a Question{" "}
                </ModalHeader>
                <ModalBody>
                  <div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="input-group">
                          <select
                            class="form-control"
                            required
                            name="askcourseTopic"
                            id="askcourseTopic"
                            placeholder="Select Topic"
                            onChange={(e) =>
                              this.setState({
                                askcourseTopic: e.target.value,
                              })
                            }
                          >
                            <option value="null">Select Course Topic </option>
                            {this.state.topiclist.map((itemn, index) => (
                              <>
                                {" "}
                                <option value={itemn.topic}>
                                  {itemn.topic}
                                </option>
                              </>
                            ))}
                          </select>
                        </div>
                        <br />
                        <div class="input-group">
                          <TextField
                            id="qtitle"
                            name="qtitle"
                            style={{ width: "100%" }}
                            onChange={(e) =>
                              this.setState({
                                title: e.target.value,
                              })
                            }
                            label="Question Title"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <TitleIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                        <br />
                        <div class="input-group">
                          <TextField
                            name="description"
                            id="description"
                            style={{ width: "100%" }}
                            value={this.state.description}
                            onChange={(e) =>
                              this.setState({
                                description: e.target.value,
                              })
                            }
                            label="Description"
                            multiline
                            rowsMax={2}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <DescriptionIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                          {/* <textarea
                          class="form-control"
                          placeholder="Description"
                          name="description"
                          id="description"
                          value={this.state.description}
                          onChange={(e) =>
                            this.setState({
                              description: e.target.value,
                            })
                          }
                          rows={5}
                          cols={120}
                        ></textarea> */}
                        </div>
                        <br />
                        <div class="input-group">
                          <TextField
                            style={{ width: "100%" }}
                            id="selectedAnsFile"
                            type="file"
                            name="selectedAnsFile"
                            onChange={(e) =>
                              this.setState({
                                selectedAnsFile: e.target.files[0],
                              })
                            }
                            label="Upload File"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <FileCopyIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                          {/* <input
                          class="form-control"
                          id="selectedAnsFile"
                          type="file"
                          name="selectedAnsFile"
                          onChange={(e) =>
                            this.setState({
                              selectedAnsFile: e.target.files[0],
                            })
                          }
                        /> */}
                        </div>
                        <br />
                        <div className="row">
                          <div className="col-lg-12 text-center">
                            <Button
                              variant="contained"
                              color="primary"
                              disabled={this.state.loading}
                              onClick={(e) => this.handleSubmit(e)}
                            >
                              Post
                            </Button>

                            {this.state.loading === true ? (
                              <CircularProgress
                                size={24}
                                color="green"
                                className="buttonProgress1"
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ModalBody>
              </Modal>
              <br />
            </div>
          </div>{" "}
          <br />
          <div class="row">
            <div class="col-md-8">
              <select
                class="form-control"
                required
                name="courseTopic"
                id="courseTopic"
                onChange={this.selectCourseTopic}
              >
                {" "}
                <option value="null">All</option>
                {this.state.topiclist.map((itemn, index) => (
                  <>
                    {" "}
                    <option value={itemn.topic}>{itemn.topic}</option>
                  </>
                ))}
              </select>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-12">
              <center>
                <label>
                  {" "}
                  <input
                    type="checkbox"
                    id="myque"
                    name="myque"
                    checked={this.state.checked}
                    onChange={(e) =>
                      this.setState({
                        checked: !this.state.checked,
                      })
                    }
                  />{" "}
                  Questions I have asked
                </label>
              </center>
            </div>
          </div>
        </div>
        <br />
        <br />
        {this.state.isSearchedata === true ? (
          <>
            {filterData.length === 0 ? (
              <>
                <Row>
                  <Col sm={12}><p> No matches found</p></Col>
                </Row>
              </>
            ) : (
              <>
                {filterData.map((item, index1) => (
                  <>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col sm={12}>
                            <div class="row">
                              <div class="col-md-9">
                                <div class="row">
                                  <div class="col-sm-1">
                                    <div class="pull-left">
                                      <img
                                        src={item.postedbyimage}
                                        alt=""
                                        class="qna-img"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-sm-10">
                                    {item.qtitle != null ? (
                                      <>
                                        <Anchor
                                          onClick={(e) =>
                                            this.routeChange(
                                              e,
                                              item.qtitle,
                                              item.qpostedby,
                                              item.qcreationdate,
                                              item.qforumthreadsSize,
                                              item.qdescription,
                                              item.qfile,
                                              item.qid
                                            )
                                          }
                                          ///onClick={this.routeChange}
                                          // to={{
                                        >
                                          {item.qtitle}{" "}
                                        </Anchor>
                                      </>
                                    ) : (
                                      <>
                                        <Anchor
                                          onClick={(e) =>
                                            this.routeChange(
                                              e,
                                              "NEW TOPIC",
                                              item.qpostedby,
                                              item.qcreationdate,
                                              item.qforumthreadsSize,
                                              item.qdescription,
                                              item.qfile,
                                              item.qid
                                            )
                                          }
                                        >
                                          NEW TOPIC
                                        </Anchor>
                                      </>
                                    )}
                                  </div>
                                </div>
                                <br />
                                <p>
                                  Posted By {item.qpostedby}&nbsp; | &nbsp;{" "}
                                  {item.qcreationdate}
                                </p>
                              </div>
                              <div class="col-md-3">
                                <center>
                                  {item.qforumthreadsSize}
                                  <br /> Response{" "}
                                </center>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <br />
                  </>
                ))}
              </>
            )}
          </>
        ) : (
          <>
            {this.state.isseltopic === true ? (
              <>
                {this.state.checked === true ? (
                  <>
                    {" "}
                    {this.state.topicwiseLearnerQueList.length === 0 ? (
                      <>
                        <Row>
                          <Col sm={12}>
                            <p>No Questions found for this topic</p></Col>
                        </Row>
                      </>
                    ) : (
                      <>
                        {this.state.topicwiseLearnerQueList.map(
                          (item, index1) => (
                            <>
                              <Anchor
                                className="text-a"
                                onClick={(e) =>
                                  this.routeChange(
                                    e,
                                    item.qtitle,
                                    item.qpostedby,
                                    item.qcreationdate,
                                    item.qforumthreadsSize,
                                    item.qdescription,
                                    item.qfile,
                                    item.qid
                                  )
                                }
                              >
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col sm={12}>
                                        <div class="row">
                                          <div class="col-md-10">
                                            <div className="bg-qna1 text-left">
                                              <div class="row">
                                                <div class="col-sm-1">
                                                  <div class="pull-left">
                                                    <img
                                                      src={item.postedbyimage}
                                                      alt=""
                                                      class="qna-img"
                                                    />
                                                  </div>
                                                </div>
                                                <div class="col-sm-10">
                                                  {item.qtitle != null ? (
                                                    <>
                                                      <Anchor
                                                        onClick={(e) =>
                                                          this.routeChange(
                                                            e,
                                                            item.qtitle,
                                                            item.qpostedby,
                                                            item.qcreationdate,
                                                            item.qforumthreadsSize,
                                                            item.qdescription,
                                                            item.qfile,
                                                            item.qid
                                                          )
                                                        }
                                                        ///onClick={this.routeChange}
                                                        // to={{
                                                      >
                                                        {item.qtitle}{" "}
                                                      </Anchor>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <Anchor
                                                        onClick={(e) =>
                                                          this.routeChange(
                                                            e,
                                                            "NEW TOPIC",
                                                            item.qpostedby,
                                                            item.qcreationdate,
                                                            item.qforumthreadsSize,
                                                            item.qdescription,
                                                            item.qfile,
                                                            item.qid
                                                          )
                                                        }
                                                      >
                                                        NEW TOPIC
                                                      </Anchor>
                                                    </>
                                                  )}
                                                </div>
                                              </div>
                                              <br />
                                              <div className="text-right">
                                                Posted By {item.qpostedby}
                                                <ScheduleIcon className="schedule-icon" />{" "}
                                                {item.qcreationdate}
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-md-2">
                                            {" "}
                                            <br />
                                            <center>
                                              <Chip
                                                size="small"
                                                label={item.qforumthreadsSize}
                                                className="resp-chip"
                                              />
                                              <br /> Response{" "}
                                            </center>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Anchor>
                              <br />
                            </>
                          )
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {this.state.topicwisequesList.length === 0 ? (
                      <>
                        <Row>
                          <Col sm={12}><p>No Questions found for this topic</p></Col>
                        </Row>
                      </>
                    ) : (
                      <>
                        {this.state.topicwisequesList.map((item, index1) => (
                          <>
                            <Anchor
                              className="text-a"
                              onClick={(e) =>
                                this.routeChange(
                                  e,
                                  item.qtitle,
                                  item.qpostedby,
                                  item.qcreationdate,
                                  item.qforumthreadsSize,
                                  item.qdescription,
                                  item.qfile,
                                  item.qid
                                )
                              }
                            >
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col sm={12}>
                                      <div class="row">
                                        <div class="col-md-10">
                                          <div className="bg-qna1 text-left">
                                            <div class="row">
                                              <div class="col-sm-1">
                                                <div class="pull-left">
                                                  <img
                                                    src={item.postedbyimage}
                                                    alt=""
                                                    class="qna-img"
                                                  />
                                                </div>
                                              </div>
                                              <div class="col-sm-10">
                                                {item.qtitle != null ? (
                                                  <>
                                                    <Anchor
                                                      onClick={(e) =>
                                                        this.routeChange(
                                                          e,
                                                          item.qtitle,
                                                          item.qpostedby,
                                                          item.qcreationdate,
                                                          item.qforumthreadsSize,
                                                          item.qdescription,
                                                          item.qfile,
                                                          item.qid
                                                        )
                                                      }
                                                      ///onClick={this.routeChange}
                                                      // to={{
                                                    >
                                                      {item.qtitle}{" "}
                                                    </Anchor>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Anchor
                                                      onClick={(e) =>
                                                        this.routeChange(
                                                          e,
                                                          "NEW TOPIC",
                                                          item.qpostedby,
                                                          item.qcreationdate,
                                                          item.qforumthreadsSize,
                                                          item.qdescription,
                                                          item.qfile,
                                                          item.qid
                                                        )
                                                      }
                                                    >
                                                      NEW TOPIC
                                                    </Anchor>
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                            <br />
                                            <div className="text-right">
                                              Posted By {item.qpostedby}
                                              <ScheduleIcon className="schedule-icon" />{" "}
                                              {item.qcreationdate}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-2">
                                          {" "}
                                          <br />
                                          <center>
                                            <Chip
                                              size="small"
                                              label={item.qforumthreadsSize}
                                              className="resp-chip"
                                            />
                                            <br /> Response{" "}
                                          </center>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Anchor>
                            <br />
                          </>
                        ))}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                {this.state.checked === true ? (
                  <>
                    {this.state.quesiaskedList.length === 0 ? (
                      <>
                        <Row>
                          <Col sm={12}><p>Questions found </p></Col>
                        </Row>
                      </>
                    ) : (
                      <>
                        {this.state.quesiaskedList.map((item, index1) => (
                          <>
                            <Anchor
                              className="text-a"
                              onClick={(e) =>
                                this.routeChange(
                                  e,
                                  item.qtitle,
                                  item.qpostedby,
                                  item.qcreationdate,
                                  item.qforumthreadsSize,
                                  item.qdescription,
                                  item.qfile,
                                  item.qid
                                )
                              }
                            >
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col sm={12}>
                                      <div class="row">
                                        <div class="col-md-10">
                                          <div className="bg-qna1 text-left">
                                            <div class="row">
                                              <div class="col-sm-1">
                                                <div class="pull-left">
                                                  <img
                                                    src={item.postedbyimage}
                                                    alt=""
                                                    class="qna-img"
                                                  />
                                                </div>
                                              </div>
                                              <div class="col-sm-10">
                                                {item.qtitle != null ? (
                                                  <>
                                                    <Anchor
                                                      onClick={(e) =>
                                                        this.routeChange(
                                                          e,
                                                          item.qtitle,
                                                          item.qpostedby,
                                                          item.qcreationdate,
                                                          item.qforumthreadsSize,
                                                          item.qdescription,
                                                          item.qfile,
                                                          item.qid
                                                        )
                                                      }
                                                      ///onClick={this.routeChange}
                                                      // to={{
                                                    >
                                                      {item.qtitle}{" "}
                                                    </Anchor>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Anchor
                                                      onClick={(e) =>
                                                        this.routeChange(
                                                          e,
                                                          "NEW TOPIC",
                                                          item.qpostedby,
                                                          item.qcreationdate,
                                                          item.qforumthreadsSize,
                                                          item.qdescription,
                                                          item.qfile,
                                                          item.qid
                                                        )
                                                      }
                                                    >
                                                      NEW TOPIC
                                                    </Anchor>
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                            <br />
                                            <div className="text-right">
                                              Posted By {item.qpostedby}
                                              <ScheduleIcon className="schedule-icon" />{" "}
                                              {item.qcreationdate}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-2">
                                          {" "}
                                          <br />
                                          <center>
                                            <Chip
                                              size="small"
                                              label={item.qforumthreadsSize}
                                              className="resp-chip"
                                            />
                                            <br /> Response{" "}
                                          </center>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Anchor>
                            <br />
                          </>
                        ))}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {this.state.allquesList.length === 0 ? (
                      <>
                        <center>
                          <img
                            dir="images"
                            src="/assets/images/icons/no-announcement.svg"
                            alt=""
                            width="200"
                            height="150"
                            className="img-thumbnail"
                          />
                          <br /> <br />
                          <h6>" No Discussion !"</h6>
                        </center>
                      </>
                    ) : (
                      <>
                        {this.state.allquesList.map((item, index1) => (
                          <>
                            <Anchor
                              className="text-a"
                              onClick={(e) =>
                                this.routeChange(
                                  e,
                                  item.qtitle,
                                  item.qpostedby,
                                  item.qcreationdate,
                                  item.qforumthreadsSize,
                                  item.qdescription,
                                  item.qfile,

                                  item.qid
                                )
                              }
                            >
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col sm={12}>
                                      <div class="row">
                                        <div class="col-md-10">
                                          <div className="bg-qna1 text-left">
                                            <div class="row">
                                              <div class="col-sm-1">
                                                <div class="pull-left">
                                                  <img
                                                    src={item.postedbyimage}
                                                    alt=""
                                                    class="qna-img"
                                                  />
                                                </div>
                                              </div>
                                              <div class="col-sm-10">
                                                {item.qtitle != null ? (
                                                  <>
                                                    <Anchor
                                                      onClick={(e) =>
                                                        this.routeChange(
                                                          e,
                                                          item.qtitle,
                                                          item.qpostedby,
                                                          item.qcreationdate,
                                                          item.qforumthreadsSize,
                                                          item.qdescription,
                                                          item.qfile,

                                                          item.qid
                                                        )
                                                      }
                                                      ///onClick={this.routeChange}
                                                      // to={{
                                                    >
                                                      {item.qtitle}{" "}
                                                    </Anchor>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Anchor
                                                      onClick={(e) =>
                                                        this.routeChange(
                                                          e,
                                                          "NEW TOPIC",
                                                          item.qpostedby,
                                                          item.qcreationdate,
                                                          item.qforumthreadsSize,
                                                          item.qdescription,
                                                          item.qfile,

                                                          item.qid
                                                        )
                                                      }
                                                    >
                                                      NEW TOPIC
                                                    </Anchor>
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                            <div className="text-right">
                                              Posted By {item.qpostedby}
                                              <ScheduleIcon className="schedule-icon" />{" "}
                                              {item.qcreationdate}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-2">
                                          <br />
                                          <center>
                                            <Chip
                                              size="small"
                                              label={item.qforumthreadsSize}
                                              className="resp-chip"
                                            />
                                            <br /> Response{" "}
                                          </center>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Anchor>
                            <br />
                          </>
                        ))}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
    );
  }
}

export default QandA;
